<template>
    <listings-activation-store
        v-slot="{
            sid,
            error,
            is_loading: is_saving,
            store
        }"
        :params="{
            listing: listing.uuid
        }"
        @success="_.debounce(() => {
            show_store_modal = false

            _.debounce(() => {
                show_stored_modal = true
            })()
        })()"
    >
        <div>
            <button
                class="w-full px-4 py-3 text-center text-white rounded-b bg-green sm:px-6"
                @click.prevent="_.debounce(() => { show_store_modal = true })()"
            >
                Activate Listing
            </button>

            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
            />

            <modal-blue
                v-else-if="show_store_modal"
                v-slot="{ close }"
                :is-open="show_store_modal"
                @close="_.debounce(() => { show_store_modal = false })()"
            >
                <landlords-current
                    v-slot="{ data: { account } }"
                >
                    <base-form @submit="store">
                        <div class="px-4 pt-4 pb-3 sm:p-6">
                            <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                                <template v-if="account.status === account.consts.status.verified">
                                    Activate Listing
                                </template>

                                <template v-else>
                                    Account verification
                                </template>
                            </h6>

                            <div class="text-grey-darker">
                                <p class="mb-3">
                                    <template v-if="account.status === account.consts.status.verified">
                                        Once activated your listing, it will begin showing up in search results
                                        and become available for prospective tenants to submit applications.
                                    </template>

                                    <template v-else>
                                        We need you to
                                        <router-link
                                            :to="{ name: $router.fix('dashboard.*.verification.edit') }"
                                            class="no-underline text-blue"
                                        >
                                            verify your account
                                        </router-link>
                                        before activating your listing.
                                    </template>
                                </p>
                            </div>
                        </div>

                        <footer class="flex flex-col px-6 py-3 rounded-b md:flex-row-reverse bg-grey-bg">
                            <base-button
                                v-if="account.status === account.consts.status.verified"
                                :is-loading="is_saving"
                                type="submit"
                                class="w-full btn btn-blue md:w-auto"
                            >
                                Activate
                            </base-button>

                            <router-link
                                v-else
                                slot="footer"
                                :to="{ name: $router.fix('dashboard.*.verification.edit') }"
                                class="w-full btn btn-blue md:w-auto"
                            >
                                Verify Account
                            </router-link>

                            <button
                                type="button"
                                class="text-center btn md:mr-3"
                                @click.prevent="close"
                            >
                                Cancel
                            </button>
                        </footer>
                    </base-form>
                </landlords-current>
            </modal-blue>

            <modal-success
                v-else-if="show_stored_modal"
                :is-open="show_stored_modal"
                @close="_.debounce(() => { show_stored_modal = false })(); $emit('success')"
            >
                <template v-slot:heading>Listing activated!</template>

                <p class="mb-3">
                    Your listing will now showing up in search results and is accepting applications.
                </p>

                <p class="mb-3">
                    Share your listing link directly with anyone who you think might be interested, or share it
                    on social media/other sites.
                </p>

                <p class="mb-3">
                    We'll send you an email when anyone applies - or you can check your applications to
                    see any activity.
                </p>

                <template
                    v-slot:footer="{
                        close
                    }"
                >
                    <div class="flex flex-col md:flex-row-reverse">
                        <button
                            type="button"
                            @click.prevent="close"
                            class="text-center btn btn-green"
                        >
                            OK
                        </button>
                    </div>
                </template>
            </modal-success>
        </div>
    </listings-activation-store>
</template>

<script>
    import LandlordsCurrent from '../../../../../components/landlords-current'
    import ListingsActivationStore from '../../../../../components/listings-activation-store'

    export default {
        components: {
            LandlordsCurrent,
            ListingsActivationStore
        },
        props: {
            listing: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_store_modal: false,
                show_stored_modal: false
            }
        }
    }
</script>
